var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXdcTwitterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7142 7.62262L17.4162 0H15.8286L10.0068 6.61726L5.3604 0H0L7.0278 10.0074L0 17.9999H1.5876L7.7316 11.0104L12.6396 17.9999H18M2.1606 1.17142H4.5996L15.8274 16.8861H13.3878",
    fill: "#717184"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXdcTwitterIcon);
export default __webpack_public_path__ + "static/media/xdc-twitter-icon.aa1c3a5f77c019ba157cfbadcf906e19.svg";
export { ForwardRef as ReactComponent };